<template>
	<div class="mall-goods-container">
		<div class="mall-goods-detail">
			<!-- 返回按钮 -->
			<div class="back-bar">
				<el-button type="text" class="back-btn" @click="handleGoBack">
					<i class="el-icon-arrow-left"></i>
					返回
				</el-button>
			</div>

			<!-- 上方：商品信息 -->
			<div class="goods-info-section">
				<!-- 左侧：图片轮播 -->
				<div class="goods-gallery">
					<div class="main-image">
						<img :src="mainImage" :alt="goodsInfo.title" />
					</div>
				</div>

				<!-- 右侧：商品信息 -->
				<div class="goods-meta">
					<h1 class="goods-title">{{ goodsInfo.title }}</h1>
					<div class="goods-tags">
						<el-tag v-for="(tag, index) in goodsInfo.tags" :key="index" size="small" type="success" class="meta-tag">
							{{ tag }}
						</el-tag>
					</div>

					<div class="meta-list">
						<div class="meta-item">
							<span class="meta-label">商品价格：</span>
							<span class="meta-value price-value">{{ goodsInfo.price }}</span>
						</div>
						<div class="meta-item">
							<span class="meta-label">所属类目：</span>
							<el-tag v-for="(cat, index) in goodsInfo.categories" :key="index" size="small" type="primary" class="meta-tag">
								{{ cat }}
							</el-tag>
						</div>
						<div class="meta-item">
							<span class="meta-label">发货时间：</span>
							<span class="meta-value highlight-text">1天</span>
						</div>
						<div class="meta-item">
							<span class="meta-label">发货约定：</span>
							<span class="meta-value">购买商品服务后线上开通交付</span>
						</div>
					</div>

					<!-- 联系我们 -->
					<!-- <div class="contact-box">
						<div class="contact-left">
							<i class="el-icon-phone-outline contact-icon"></i>
							<div class="contact-info">
								<div class="contact-label">联系我们</div>
								<div class="contact-phone">{{ goodsInfo.contactPhone || 'xxx（请填写联系方式）' }}</div>
							</div>
						</div>
						<el-button type="text" class="copy-btn" @click="handleCopyPhone">
							<i class="el-icon-document-copy"></i>
							复制信息
						</el-button>
					</div> -->

					<!-- 操作按钮 -->
					<div class="action-btns">
						<el-button type="primary" size="medium" class="consult-btn" @click="handleConsult">立即咨询</el-button>
						<el-button type="warning" size="medium" class="cart-btn" @click="handleAddCart">
							<i class="el-icon-shopping-cart-2"></i>
							加入购物车
						</el-button>
					</div>
				</div>
			</div>

			<!-- 下方：服务详情 -->
			<div class="service-detail-section">
				<div class="section-header">
					<div class="section-tab active">服务详情</div>
				</div>
				<div class="detail-content">
					<p>
						专为住建建筑行业定制的合规电子签章服务，适配建筑全业务场景线上签署需求，支持多格式文件、批量签章、多平台通用签署能力，覆盖建筑市场备案、施工图审查、图纸签署、联合验收、合同网签、资质审批全流程。替代传统纸质盖章模式，全程线上电子化操作，合规高效、一物通用，助力建筑企业、建设单位、设计勘察机构实现业务无纸化、办事提效、流程标准化，满足住建行业官方备案与合规存档要求。
					</p>
					<h3>服务范围</h3>
					<p>
						1.
						建筑市场一体化签署：支持企业投标信息登记表、人员登记真实性承诺书、诚信守法承诺书、法人授权委托书、负责人任命书、驻场负责人授权委托书等文件在线签章。
					</p>
					<p>
						2.
						建筑工程施工图审查签署：适配房建、市政工程施工图联合审查，支持审查意见通知书、合格证书、低风险工程勘察设计质量承诺书、竣工图等官方文件签署。
					</p>
					<p>
						3.
						施工图纸批量签章：支持CAD批量转PDF、DWF格式转换，可对PDF、DWF图纸批量加盖电子签章，一键通用适配住建一体化平台、合同网签等多类平台。
					</p>
					<p>
						4.
						建筑工程联合验收签署：覆盖立项用地、工程建设、竣工验收全阶段，支持可研批复、竣工结算备案表、人防工程质量保修书、防护设备保修书、竣工结算造价成果文件等验收资料签章。
					</p>
					<p>5. 建筑行业合同网签：适配勘察、设计、施工、监理、造价咨询、混凝土、工程总承包等全主体工程合同在线签章。</p>
					<p>
						6. 企业资质审批签章：覆盖企业资质、监理资质、设计勘察资质、施工安全生产许可证等十大住建审批事项配套文件在线合规签章。
					</p>
					<h3>服务流程</h3>
					<p>1. 下单购买：用户线上选购电子签章年度服务，完成订单支付</p>
					<p>2. 信息核对：工作人员1个工作日内核对企业信息、使用场景及备案资料</p>
					<p>3. 线上开通：校验无误后完成电子签章权限线上授权开通</p>
					<p>4. 实操适配：提供平台、客户端使用指引，适配图纸转换、批量签章、多平台签署操作</p>
					<p>5. 正式启用：用户可自主开展全场景线上签章业务，享受年度服务权益</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 * @description 商城商品详情页
	 */
	export default {
		name: 'MallGoodsDetail',
		data() {
			return {
				activeImageIndex: 0,
				goodsInfo: {
					title: '电子签章',
					images: [require('@/assets/mall/goods/goods-signature.png')],
					tags: ['电子签章'],
					categories: ['企业业务办事辅助', '电子签章'],
					price: '400元/年',
					contactPhone: '1859234781'
				}
			}
		},
		computed: {
			mainImage() {
				return this.goodsInfo.images[this.activeImageIndex] || this.goodsInfo.images[0]
			}
		},
		methods: {
			// 返回上一页
			handleGoBack() {
				this.$router.back()
			},
			// 切换主图
			handleSwitchImage(index) {
				this.activeImageIndex = index
			},
			// 复制联系方式
			handleCopyPhone() {
				const phone = this.goodsInfo.contactPhone || ''
				if (!phone) {
					this.$message.warning('暂无联系方式')
					return
				}
				if (navigator.clipboard) {
					navigator.clipboard
						.writeText(phone)
						.then(() => {
							this.$message.success('复制成功')
						})
						.catch(() => {
							this.$message.error('复制失败')
						})
				} else {
					// 降级方案
					const input = document.createElement('input')
					input.value = phone
					document.body.appendChild(input)
					input.select()
					document.execCommand('copy')
					document.body.removeChild(input)
					this.$message.success('复制成功')
				}
			},
			// 立即咨询
			handleConsult() {
				// this.$message.info('咨询功能开发中')
			},
			// 加入购物车
			handleAddCart() {
				// this.$message.success('已加入购物车')
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/views/mall/goodsDetail/goodDetail.scss';
</style>
